/**
 * What a visitor sees on a domain no club has (phase 2 custom domains,
 * PM 01fda321): an unknown host, or a club's domain that is not active yet.
 * It never falls back to a default club. Rendered by index.tsx in place of
 * the app, so it carries its own ThemeProvider and needs no store or router.
 */
import React from "react";
import { ThemeProvider } from "../../context/ThemeContext";
import { Button, Card, PageContainer, PageHeading } from "../ui";

interface UnknownHostPageProps {
  host: string;
  /** "not_found": no club is set up here. "error": Club Central could not be reached. */
  reason: "not_found" | "error";
}

const UnknownHostPage: React.FC<UnknownHostPageProps> = ({ host, reason }) => (
  <ThemeProvider>
    <PageContainer>
      <div className="max-w-xl mx-auto mt-16" data-testid="unknown-host-page">
        {reason === "not_found" ? (
          <Card padding="lg">
            <PageHeading
              title="This site is not set up"
              subtitle={`No club is set up at ${host} yet.`}
            />
            <p className="text-sm text-gray-600 dark:text-gray-300">
              If this is your club&apos;s domain, open Club Central and check the domain screen under
              Settings. Your club&apos;s site appears here once its domain is active.
            </p>
          </Card>
        ) : (
          <Card padding="lg">
            <PageHeading
              title="We could not load this site"
              subtitle="Club Central did not answer. Check your connection and try again."
            />
            <Button variant="primary" size="md" onClick={() => window.location.reload()}>
              Try again
            </Button>
          </Card>
        )}
      </div>
    </PageContainer>
  </ThemeProvider>
);

export default UnknownHostPage;
